module.exports = __webpack_public_path__ + "assets/img/webinar-logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/webinar-logo.png
// module id = 1993
// module chunks = 0